<template>
  <f7-list media-list v-if="messages" id="payments-item-received" class="itemList" :style="itemListStyle">
    <li v-for="message in messages" :key="message.id"
      :class="{messageSelected: message.id && message.id === actualMessageId}"
      :style="{background: getSeenStatusBackground(message.isRead)}">
      <div @click="seeDetails(message, true)">
        <div class="item-content boxRequest">
          <div class="item-media">
            <f7-icon :icon="getIcon(message)" class="list-icon"></f7-icon>
          </div>
          <div class="item-inner">
            <div class="item-title-row">
              <table width="100%">
                <tr>
                  <td style="width: 27.5%;min-width: 27.5%;max-width: 27.5%;">
                    <div :style="{fontWeight: getSeenStatusFontWeight(message.isRead)}">
                      {{ getMessageLabel(message) }}
                      <span v-if="notEmpty(message.attachmentId)" class="paperclip">
                        &nbsp;<f7-icon fa="paperclip"></f7-icon>
                      </span>
                      <span v-else-if="notEmpty(message.AttachmentsNumber)" class="paperclip">
                        &nbsp;<f7-icon fa="paperclip" v-for="id in message.AttachmentsNumber" :key="id"></f7-icon>
                      </span>
                    </div>
                  </td>
                  <td style="width: 27.5%;min-width: 27.5%;max-width: 27.5%; padding-right: 5%;"
                    class="showLargeScreenOnly"
                    v-if="serviceId === services.PAYMENTS">
                    <div class="text-center" :style="{'font-weight': getSeenStatusFontWeight(message.isRead)}">
                      <label style="width: 47.5%; margin-top: 5px !important;"
                        :class="getDirectionClass(message)" class="text-center m-0">
                        {{ getDirectionSymbol(message) }} {{ getAmount(message) }} €
                      </label>
                    </div>
                  </td>
                  <td style="width: 27.5%;min-width: 27.5%;max-width: 27.5%; padding-right: 5%;"
                    class="showLargeScreenOnly"
                    v-if="serviceId === services.DIRECTPAYMENTS">
                    <div class="text-center" :style="{'font-weight': getSeenStatusFontWeight(message.isRead)}">
                      <label :class="[message.direction === '0' ? 'positif_amount' : 'negatif_amount']"
                        class="text-center m-0">
                        {{ message.direction === '0' ? '+' : '-' }} {{ getAmount(message) }} €
                      </label>
                    </div>
                  </td>
                  <td style="width: 20%;min-width: 20%;max-width: 20%;" class="showLargeScreenOnly"
                    v-if="serviceId === services.DOCUMENTSERVICE">
                    {{ getDocumentInfo(message) }}
                  </td>
                  <td style="width: 20%;min-width: 20%;max-width: 20%;" class="showLargeScreenOnly" v-else>
                    <div v-if="message.TotalPayments">
                      {{ message.TotalPayments + ' paiements' }}
                    </div>
                    <div v-else-if="message.direction === '0'">
                      {{ $t('common.from_label') + ': ' + getSenderName(message)}}
                    </div>
                    <div v-else>
                      {{ $t('common.to_label') + ': ' + getRecipientName(message) }}
                    </div>
                  </td>
                  <td class="showLargeScreenOnly" style="width: 25%;min-width: 25%;max-width: 25%;">
                    <div class="item-after">
                      <span>{{ datePresentationLabel }} {{ getDate(message) | formatDate }}</span>
                      <!-- <div class="swipeout-actions-right showSmallScreenOnly">
                        <a href="#" class="swipeout-delete">{{ $t('common.del_label') }}</a>
                      </div>
                      <div class="item-media showLargeScreenOnly" v-if="canDelete()">
                        <button class="button-swipe-out" @click="deleteOnWeb(message.id, $event)">
                          <f7-icon f7="close" class="button-delete close_margin"></f7-icon>
                        </button>
                      </div> -->
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            <div class="item-title-row" style="justify-content: normal;">
              <div class="item-subtitle showSmallScreenOnly smallScreenStatementDescription"
                v-if="message.TotalPayments">
                {{ message.TotalPayments + ' paiements' }}
              </div>
              <div class="item-subtitle showSmallScreenOnly smallScreenStatementDescription"
                v-else-if="message.direction === '0'">
                {{ $t('common.from_label') + ': ' + getSenderName(message) }}
              </div>
              <div class="item-subtitle showSmallScreenOnly smallScreenStatementDescription"
                v-else>
                {{ $t('common.to_label') + ': ' + getRecipientName(message) }}
              </div>
              <div class="item-subtitle showSmallScreenOnly" style="margin-left:auto;"
                :class="getDirectionClass(message)">
                {{ getDirectionSymbol(message) }} {{ getAmount(message) }} €
              </div>
              <div class="showLargeScreenOnly" style="width: 27.5%; min-width: 27.5%; max-width: 27.5%;">
                <span class="statusLabel">
                  {{ getStatusLabel(message) }}
                </span>
              </div>
              <div class="text-center" style="width: 27.5%; min-width: 27.5%; max-width: 27.5%;padding-right:5%"
                v-if="showAmountCreditDebit(message)">
                <span class="positif_amount">
                  {{ '+' + message.AmountCredit }} €
                </span>
                <span class="negatif_amount">
                  {{ '-' + message.AmountDebit }} €
                </span>
              </div>
              <div class="showLargeScreenOnly text-center" style="width: 27.5%; min-width: 27.5%; max-width: 27.5%;padding-right:5%"
                v-else>
                <span class="text-center statusLabel m-0" v-if="serviceId === services.PAYMENTS">
                  {{ message.direction === '1' ? getBankAccountCreditor(message) : getBankAccountDebitor(message) }}
                </span>
                <span class="text-center statusLabel m-0">
                  {{ message.direction === '0' ? getBankAccountCreditor(message) : getBankAccountDebitor(message) }}
                </span>
              </div>
              <div style="width: 27.5%; min-width: 27.5%; max-width: 27.5%;"
                v-if="message.TotalPaymentsAction">
                <span class="statusLabel showLargeScreenOnly">
                  {{ 'dont ' + message.TotalPaymentsAction + ' à traiter' }}
                </span>
              </div>
            </div>
            <div class="item-title-row showSmallScreenOnly">
              <div class="item-subtitle showSmallScreenOnly"
                v-if="serviceId === services.DOCUMENTSERVICE"
                style="white-space:normal">
                {{ getDocumentInfo(message) }}
              </div>
            </div>
            <div class="item-title-row showSmallScreenOnly">
              <div class="statusLabel">
                {{ getStatusLabel(message) }}
              </div>
              <div class="item-after">
                <f7-icon class="orangeFont" v-if="message.reminder === '1'" fa="bell"></f7-icon>
              </div>
            </div>
          </div>
          <!-- TLV 15/02/2021 : Code de suppliers de François à déplacer dans Suppliers List asap-->
          <!-- <div class="item-media" v-if="serviceId === services.SUPPLIERS">
            <div class="swipeout-actions-right showSmallScreenOnly">
              <a href="#" class="swipeout-delete">{{ $t('common.del_label') }}</a>
            </div>
            <div class="item-media showLargeScreenOnly" v-if="canDelete()">
              <button class="button-swipe-out" @click="deleteOnWeb(message.IdSeller, $event)">
                <f7-icon f7="close" class="button-delete close_margin"></f7-icon>
              </button>
            </div>
            <div class="swipeout-actions-right showSmallScreenOnly">
              <a href="#" class="swipeout-statement">{{ $t('common.edit_label') }}</a>
            </div>
            <div class="item-media showLargeScreenOnly" v-if="canDelete()">
              <button class="button-swipe-out" @click="editSupplier(message.IdSeller, $event)">
                <f7-icon f7="" class="fa fa-pencil button-edit close_margin"></f7-icon>
              </button>
            </div>
          </div> -->
        </div>
      </div>
    </li>
  </f7-list>
</template>

<script>
  import {
    errorMessageAlert
  } from '@/helpers/alert'
  import {
    loadPage
  } from '@/helpers/routing'
  import {
    statusLabel,
    statusIcon,
    getSeenStatusBackground,
    getSeenStatusFontWeight
  } from '@/helpers/labels'
  import {
    isEmptyValue
  } from '@/helpers/validator'
  import services from '@/helpers/services'

  export default {
    name: 'TransactionsList',
    props: [
      'actualMessageId',
      'filterBy',
      'itemListStyle',
      'messages',
      'randomId',
      'serviceId'
    ],
    data: () => {
      return {
        icon: 'help',
        fromIdToServiceName: {
          '1': 'payments',
          '2': 'directDebit',
          '6': 'directPayments'
        },
        services: services
      }
    },
    computed: {
      filteredMessage () {
        if (this.filterBy) {
          return this.messages.filter((a) => {
            return a.remittanceInformation.toLowerCase().includes(this.filterBy.toLowerCase()) ||
            a.creditorName.toLowerCase().includes(this.filterBy.toLowerCase())
          })
        }
        return this.messages
      },
      datePresentationLabel () {
        if (this.serviceId === '7' || this.serviceId === '8') {
          return this.$t('businessDocuments.shared_folder_creation_date')
        }
        return this.$t('common.oper_date') + ': '
      }
    },
    mounted () {
      for (let i = 0; i < this.messages.length; i++) {
        if (this.messages[i].amountResponse) {
          this.messages[i].amountResponse = parseFloat(this.messages[i].amountResponse) % 1 === 0
            ? this.messages[i].amountResponse
            : parseFloat(this.messages[i].amountResponse).toFixed(2)
        }
        this.messages[i].amount = parseFloat(this.messages[i].amount) % 1 === 0
        ? this.messages[i].amount
        : parseFloat(this.messages[i].amount).toFixed(2)
      }
    },
    methods: {
      canDelete () {
        if (this) {
          // DISABLED
          return
        }
        let that = this
        // Tous les comptes particuliers peuvent supprimer une demande
        if (that.$engine.user.get().type === '2') {
          return true
        }
        for (var i = 0; i < that.$settings.currentAccount.userAccts.length; i++) {
          if (that.$settings.currentAccount.userAccts[i].id === that.$engine.user.userAccountId) {
            if (that.$engine.user.get().type === '1' && that.$settings.currentAccount.userAccts[i]['Payments'] ===
              '1') {
              return true
            }
          }
        }
        return false
      },
      deleteOnWeb (payId, e) {
        e.stopPropagation()
        let that = this
        var msgPopupText = ''
        var serviceID = this.serviceId
        if (serviceID === '8') {
          msgPopupText = this.$i18n.t('suppliers.pop_up_del_suppliers')
        } else {
          msgPopupText = this.$i18n.t('directPayments.pop_up_del_pymnt')
        }
        this.$f7.modal({
          title: this.$i18n.t('common.del_label') + ' ?',
          text: msgPopupText,
          buttons: [{
            text: this.$i18n.t('common.cncl'),
            color: 'red',
            onClick: function () {}
          },
          {
            text: this.$i18n.t('common.yes_label'),
            onClick: function () {
              var list = that.filteredMessage
              var idPaymentInList = -1
              for (var i = 0; i < list.length; i++) {
                if (list[i].id === payId) {
                  idPaymentInList = i
                  break
                }
              }
              list.splice(idPaymentInList, 1)
              if (serviceID === '8') {
                var idSeller = payId
                var sellerIdentifier = list[0].SellerIdentifier
                that.deleteSupplier(idSeller, sellerIdentifier)
              } else {
                that.deletePayments(payId)
              }
            }
          }]
        })
      },
      deletePayments (payId) {
        let that = this
        that.$engine.services[this.fromIdToServiceName[this.serviceId]].delete(payId)
        .then(response => {
          if (response.status === 200) {}
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that, this.$i18n)
        })
      },
      deleteSupplier (idSeller, sellerIdentifier) {
        let that = this
        that.$engine.services[this.fromIdToServiceName[this.serviceId]].delete(idSeller, sellerIdentifier)
        .then(response => {
          if (response.status === 200) {}
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that, this.$i18n)
        })
      },
      getAdditionalInfo (message) {
        return this.$t('common.srn') + ' : ' + message.Siren
      },
      getAmount (message) {
        if (message.amountResponse) {
          return message.amountResponse
        } else if (message.Amount) {
          return message.Amount.replace('-', '')
        } else {
          return message.amount
        }
      },
      getBankAccountCreditor (message) {
        let tmp = this.$engine.bankAccounts.get().find(elem => elem.iban === message.creditorBankAccount)
        if (tmp) {
          return tmp.name
        }
      },
      getBankAccountDebitor (message) {
        let tmp = this.$engine.bankAccounts.get().find(elem => elem.iban === message.debtorBankAccount)
        if (tmp) {
          return tmp.name
        }
      },
      getDate (message) {
        if (message.executionDateResponse) {
          return message.executionDateResponse
        } else if (message.date) {
          return message.date
        } else if (message.requestedExecutionDate) {
          return message.requestedExecutionDate
        } else if (message.Date) {
          return message.Date
        } else {
          return message.creationDate
        }
      },
      getDirectionClass (message) {
        if (message.direction === '1' ||
          (message.Amount && parseFloat(message.Amount) >= 0)) {
          return 'positif_amount'
        } else {
          return 'negatif_amount'
        }
      },
      getDirectionSymbol (message) {
        if (message.direction === '1' ||
          (message.Amount && parseFloat(message.Amount) >= 0)) {
          return '+'
        } else {
          return '-'
        }
      },
      getDocumentInfo (message) {
        let countDocumentToTreat = message.nb_docs_to_process
        if (countDocumentToTreat > 0) {
          return this.$i18n.t('businessDocuments.document_to_treat_left', {
            number_doc_left: countDocumentToTreat,
            number_doc_total: message.nb_docs_total
          })
        } else {
          return this.$i18n.t('businessDocuments.no_document_to_treat_left')
        }
      },
      getIcon (message) {
        let status = ''
        if (this.serviceId === '7' || message.GroupIdentifier) {
          if (message.Status) {
            status = 'Folder_' + message.Status
          } else {
            status = 'Folder_' + message.status
          }
        } else {
          status = message.status
        }
        return statusIcon(status, message.negotStatus)
      },
      getMessageLabel (message) {
        if (message.reference) {
          return message.reference
        } else if (message.Name) {
          return message.Name
        } else {
          return message.reason
        }
      },
      getRecipientName (message) {
        if (this.serviceId === '6') {
          return message.creditorName
        } else if (this.serviceId === '7') {
          if (this.$engine.user.get().identifier === message.owner) {
            return message.correspondent
          } else {
            return message.owner
          }
        }
        if (message.debtorName === undefined || message.debtorName === '') {
          return this.$t('requestToPay.anon_debtor')
        } else {
          return message.debtorName
        }
      },
      getSeenStatusBackground (isRead) {
        return getSeenStatusBackground(isRead)
      },
      getSeenStatusFontWeight (isRead) {
        return getSeenStatusFontWeight(isRead)
      },
      getSenderName (message) {
        if (this.serviceId === '6') {
          return message.debtorName
        }
        return message.creditorName
      },
      getStatusLabel (message) {
        if (this.serviceId === '7' || message.GroupIdentifier) {
          let status
          if (this.serviceId === '1' && message.Status) {
            status = 'PaymentGroup_' + message.Status
          } else {
            status = 'Folder_' + message.status
          }
          return statusLabel(this.$i18n, status, message.negotStatus, message.direction)
        }
        return this.$i18n.t('common.status.status_label') + ': ' + statusLabel(this.$i18n, message.status, message
          .negotStatus, message.direction)
      },
      notEmpty (value) {
        return !isEmptyValue(value)
      },
      onSwipeoutDeleted (payId) {
        if (this.serviceId === '8') {
          var idSeller = payId
          var list = this.filteredMessage
          var idPaymentInList = -1
          list.splice(idPaymentInList, 1)
          var sellerIdentifier = list[0].SellerIdentifier
          this.deleteSupplier(idSeller, sellerIdentifier)
        } else {
          this.deletePayments(payId)
        }
      },
      seeDetails (message, isReceived) {
        let that = this
        if (message.direction === '0') {
          switch (this.serviceId) {
            case '2':
              this.$engine.services.directDebit.currentInbox = message
              break
            case '6':
              this.$engine.services.directPayments.currentInbox = message
              break
            default:
              break
          }
        } else {
          switch (this.serviceId) {
            case '2':
              this.$engine.services.directDebit.currentSendbox = message
              break
            case '6':
              this.$engine.services.directPayments.currentSendbox = message
              break
            case '7':
              this.$engine.services.businessDocuments.currentSendbox = message
              message.direction = ''
              break
            default:
              break
          }
        }
        let redirectionUrl = {
          '1': '/payments/transaction-details/',
          '2': '/directDebit/details/' + message.direction + '/',
          '6': message.idgroup ? '/directPaymentsGroup/details/' : 'directPayments/details/',
          '7': '/businessDocument/details/'
        }
        if (message.GroupIdentifier) {
          let filterConditions
          if (this.$engine.services.payments.filter.getDefaultFilter()) {
            filterConditions = this.$engine.services.payments.filter.getDefaultFilter()
          } else {
            filterConditions = this.$engine.services.payments.filter.getConditionObject()
          }
          filterConditions.IdGroup = message.IdGroup
          this.$engine.settings.set({
            clickedMessage: {
              IdGroup: message.IdGroup,
              direction: '1'
            }
          })
          this.$engine.services.payments.update(
            2,
            1000,
            1,
            filterConditions
          ).then(resp => {
            let requests = resp.data.payments
            console.log(requests)
            that.$bus.$emit('load-message', requests[0])
          })
          .catch(error => {
            errorMessageAlert(error, this, this.$i18n)
          })
          loadPage(that, {
            url: redirectionUrl[this.serviceId]
          })
        } else {
          this.$engine.settings.set({
            clickedMessage: message
          })
          this.$engine.settings.set({
            msgFromInbox: isReceived
          })
          this.$bus.$emit('load-message', message)
          loadPage(that, {
            url: redirectionUrl[this.serviceId]
          })
        }

        // this.$f7.mainView.router.refreshPage()
        if (message.isRead && message.isRead !== '1' && this.serviceId !== '7' && this.serviceId !== '8') {
          this.updateToSeen(message.id)
        }
      },
      showAmountCreditDebit (message) {
        return message.AmountCredit &&
          parseFloat(message.AmountCredit) > 0 &&
          parseFloat(message.AmountDebit) > 0
      },
      updateToSeen (payId) {
        let that = this
        for (let i in this.messages) {
          if (this.messages[i].id === payId) {
            this.messages[i].isRead = '1'
          }
        }
        that.$engine.services[this.fromIdToServiceName[this.serviceId]]
        .setPaymentsRead({
          id: payId,
          isRead: 1
        })
        .then(response => {})
        .catch(error => {
          errorMessageAlert(error, that, this.$i18n)
        })
      }
    }
  }
</script>
<style scoped>
  .close_margin {
    margin-bottom: 10px;
  }
  .positif_amount {
    color: green;
  }
  .negatif_amount {
    color: red;
  }

</style>



// WEBPACK FOOTER //
// TransactionsList.vue?7b02e7e2